import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { DisclaimerModalComponent } from '@shared/components/disclaimer-modal/disclaimer-modal.component';
import { ClientApps } from '@shared/models';
import { AuthorizeService } from '@shared/services/authorize.service';
import { DisclaimerResponse, DisclaimerService } from '@shared/services/disclaimer.service';
import { ModalService } from '@shared/services/modal.service';
import { firstValueFrom } from 'rxjs';

export const disclaimerGuard: CanActivateFn =
  async (
    _next: ActivatedRouteSnapshot,
  ) => {
    const modalService = inject(ModalService);
    const disclaimerService = inject(DisclaimerService);
    const authService = inject(AuthorizeService);

    const isHistoric = _next.queryParams.historicResult ||
      _next.queryParams.key;

    if (isHistoric) {
      return true;
    }

    let hasReadDisclaimer: DisclaimerResponse = { disclaimerRead: true };
    if (authService.isLoggedIn) {
      const clientName = _next.data?.client as keyof typeof ClientApps | undefined;
      if (clientName) {
        hasReadDisclaimer =
          await firstValueFrom(disclaimerService.hasUserDisclaimerBeenRead(ClientApps[clientName]));
      }
    }

    if (hasReadDisclaimer.disclaimerRead) {
      return true;
    }

    return modalService
      .open({
        title: 'Disclaimer',
        component: DisclaimerModalComponent,
        size: 'xl',
        sticky: true,
        client: _next.data.client,
      }).then(() => {
        return true;
      }, () => {
        return false;
      });
  };
